module.exports = __webpack_public_path__ + "static/media/c.df7e79f2.png";